import { useAppDispatch, useAppSelector } from "../../../stores/hooks/hooks.ts";
import { useEffect } from "react";
import { RevSpinner } from "@revmatics/catalyst";
import { fetchProfileData } from "../../../stores/thunks/profileThunk.tsx";
import { fetchSubjects } from "../../../stores/thunks/helpThunk.tsx";
import { ContactUsPage } from "./ContactUsPage.tsx";

type Props = {
  showTitle?: boolean;
  useCardWrapper?: boolean;
  showSubmitButton?: boolean;
  formId?: string;
  onSuccess?: () => void;
  selectedSubjectId?: string;
};

export const ContactUsWrapperPage = ({
  showTitle,
  useCardWrapper,
  showSubmitButton,
  formId,
  onSuccess,
  selectedSubjectId,
}: Props) => {
  const profile = useAppSelector((state) => state.profile.profile);
  const isLoadingProfile = useAppSelector((state) => state.profile.isLoading);
  const subjects = useAppSelector((state) => state.help.subjects);
  const isLoadingSubjects = useAppSelector(
    (state) => state.help.isLoadingSubjects,
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!profile) {
      dispatch(fetchProfileData());
    }
  }, [dispatch, profile]);

  useEffect(() => {
    if (!subjects) {
      dispatch(fetchSubjects());
    }
  }, [dispatch, subjects]);

  if (isLoadingProfile || isLoadingSubjects) {
    return (
      <div className="h-full">
        <RevSpinner size="large" color="primary" centered />
      </div>
    );
  }

  if (profile && subjects && subjects.length > 0) {
    return (
      <ContactUsPage
        subjects={subjects}
        profile={profile}
        showTitle={showTitle}
        useCardWrapper={useCardWrapper}
        showSubmitButton={showSubmitButton}
        formId={formId}
        onSuccess={onSuccess}
        selectedSubjectId={selectedSubjectId}
      />
    );
  }
  return null;
};
